import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const TESTIMONIALS = [
  {
    id: 1,
    bgColor: "#E2FF99",
    textColor: "#242121",
    layout: "image-left",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/image%20132.png",
    text: "My skin feels softer, brighter, and healthier after just two weeks. I finally found a routine that works.",
  },
  {
    id: 2,
    bgColor: "#525D48",
    textColor: "#FFFFFF",
    layout: "image-right",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/image%20133.png",
    text: "My skin feels softer, brighter, and healthier after just two weeks. I finally found a routine that works.",
  },
  {
    id: 3,
    bgColor: "#71785F",
    textColor: "#FFFFFF",
    layout: "image-left",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/image%20134.png",
    text: "My skin feels softer, brighter, and healthier after just two weeks. I finally found a routine that works.",
  },
  {
    id: 4,
    bgColor: "#E87A00",
    textColor: "#FFFFFF",
    layout: "image-right",
    img: "https://cdn.jiro.build/Natural%20Glow/Images/image%20135.png",
    text: "My skin feels softer, brighter, and healthier after just two weeks. I finally found a routine that works.",
  },
];

export default function TestimonialNatural({ className }) {
  const containerRef = useRef(null);
  const cardsRef = useRef([]);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    const section = containerRef.current;
    if (!section) return;

    const cards = cardsRef.current.filter(Boolean);
    if (cards.length === 0) return;

    cards.forEach((card, i) => {
      if (i > 0) {
        gsap.set(card, { yPercent: 150, opacity: 0 });
      } else {
        gsap.set(card, { yPercent: 0, opacity: 1, scale: 1 });
      }
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top top",
        end: "+=" + (cards.length * 100) + "%",
        pin: true,
        scrub: 1,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    });

    cards.forEach((card, index) => {
      if (index === 0) return;

      tl.to(
        cards[index - 1],
        {
          scale: 0.95,
          opacity: 0.85,
          duration: 0.8,
          ease: "power1.out",
        },
        "step-" + index
      );

      tl.to(
        card,
        {
          yPercent: 0,
          opacity: 1,
          duration: 1,
          ease: "power1.out",
        },
        "step-" + index
      );
    });

    return () => {
      tl.scrollTrigger?.kill();
      tl.kill();
    };
  }, []);

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@400;500;600;700&display=swap" rel="stylesheet" />

      <section
        ref={containerRef}
        className={"relative w-full h-screen bg-[#F5F5F5] text-[#000] antialiased py-6 sm:py-8 px-4 sm:px-8 lg:px-12 flex flex-col justify-center items-center select-none overflow-hidden gap-4 sm:gap-6 " + (className || "")}
      >
        <div className="w-full max-w-[1520px] flex flex-col items-center justify-center h-full gap-4 sm:gap-6">

          <h2
            className="w-full text-center tracking-tighter block select-none shrink-0"
            style={{
              color: "#000000",
              fontFamily: '"Big Shoulders Display", sans-serif',
              fontSize: "clamp(48px, 16vw, 265px)",
              fontStyle: "normal",
              fontWeight: 700,
              lineHeight: "1",
              letterSpacing: "-3px",
              margin: 0,
            }}
          >
            Testimonial
          </h2>

          <div className="relative w-full max-w-[1170px] h-[360px] sm:h-[420px] md:h-[460px] lg:h-[480px] mx-auto flex items-center justify-center">
            {TESTIMONIALS.map((item, idx) => {
              const isImageLeft = item.layout === "image-left";

              return (
                <div
                  key={item.id}
                  ref={(el) => {
                    cardsRef.current[idx] = el;
                  }}
                  className="absolute top-0 left-0 right-0 w-full max-w-[1170px] mx-auto transition-shadow duration-300"
                  style={{
                    zIndex: idx + 1,
                    display: "flex",
                    padding: isImageLeft ? "16px 36px 16px 16px" : "16px 16px 16px 36px",
                    alignItems: "center",
                    gap: "40px",
                    borderRadius: "14px",
                    background: item.bgColor,
                  }}
                >
                  <div
                    className={"w-full flex flex-col lg:flex-row items-center gap-6 lg:gap-[50px] " + (isImageLeft ? "" : "lg:flex-row-reverse")}
                  >
                    <div
                      className="w-full lg:w-[480px] shrink-0 overflow-hidden"
                      style={{
                        width: "min(100%, 480px)",
                        minHeight: "220px",
                        height: "clamp(220px, 28vw, 360px)",
                        borderRadius: "12px",
                      }}
                    >
                      <img
                        src={item.img}
                        alt="Testimonial photo"
                        className="w-full h-full object-cover"
                        style={{
                          borderRadius: "12px",
                        }}
                        referrerPolicy="no-referrer"
                      />
                    </div>

                    <h3
                      className="w-full max-w-[560px] shrink leading-none"
                      style={{
                        color: item.textColor || "#FFFFFF",
                        fontFamily: '"Big Shoulders Display", sans-serif',
                        fontSize: "clamp(28px, 4vw, 70px)",
                        fontStyle: "normal",
                        fontWeight: 700,
                        lineHeight: "1.05",
                        letterSpacing: "-1.4px",
                        margin: 0,
                      }}
                    >
                      {item.text}
                    </h3>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </section>
    </>
  );
}